var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2255_11631)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.4209,
    width: 18.809,
    height: 21.4123,
    rx: 9.40449,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2255_11631",
    x: 0,
    y: 0.420898,
    width: 24.8086,
    height: 27.4121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.175 0 0 0 0 0.175 0 0 0 0 0.175 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2255_11631"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2255_11631",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2255_11631",
    transform: "matrix(0.0104167 0 0 0.00915019 0 0.060791)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2255_11631",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2ElEQVR4nO3ZwU7CQBSFYZY+T13AwsTXYqNxaXhOXWqqcf8bQolItLYwI3Nn/u8BLuWczp0EFgtJkiRJkiRJkiRJkiRJklIClsA66vzQgGvglZ3HaPND43s4pA4p9/zQ+DmcZCHlnh8a4+GcHVLu+aGxuxB7plmXNj80pr2Ze9sQlyXNDw3DN/yBb/4I105Krp0Lwp1v+AN3/gh3fkqunQvCnW/4A3f+CHe+a6cSuPMNf+DOH+HOd+1UArgCnjO++XP+yfqftbP9yyznB82dD9wCH62E/3DwgatS5gM3wHvVfyMehEOOEs6dz88lVBt+0hJSzed7CdWHn6SE1PPZlfBUS/jrnA+Uaz5wFf7CHR6sA14mPtjb3JMwc36f6eIv781vpQRKD7/mEogSfo0lEC38mkogavhHIb1GLIHo4Z/4RYoogVrCj1gCtYUfqQRqDT9CCdQefskl0Er4e8OXnvN7yirz7zV9M+EXehLaCj9gCX114Qcqoa82/BPvhPsT5i9nzG8r/JknYXPG/G7mSWgn/IklbBLM7yaW0F74f5SwSTi/+6OEdsP/pYRNhvndLyUY/tHFfJdx/vLoYjb8/8bXSTD8S2F3Etre+ZIkSZIkSZIkSdKiZJ9e9XLIuCW/bAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeen);
export default __webpack_public_path__ + "static/media/seen.5674e9162fa7b81a084ed09eb8d4e738.svg";
export { ForwardRef as ReactComponent };